<section id="wrapper" class="container content-wrapper work">
  <article class="ueber_mich">
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <h1 class="headline">Frontend/Backend Entwicklung</h1>
        <h3>Was macht ein Frontend/Backend Entwickler eigentlich?</h3>
        <p>Die Hauptaufgabe eines Frontend Entwicklers ist die Entwicklung und Darstellung einer Webseite für den jeweiligen Internetbrowser.</p>
        <p>Er ist außerdem für die Umsetzung der Layouts der Designer und immer häufiger auch für die clientseitige Programmierung zuständig.</p>
        <p>Der Backend Entwickler hingegen ist für die serverseitige Programmierung der Webseite und deren Schnittstellen vorgesehen.
        Allerdings gibt es heutzutage nicht mehr die starre Trennung zwischen Frontend und Backend Entwickler, da der Trend eher in Richtung Fullstack Entwickler geht.</p>
        <p></p>
      </div>
      <div class="col-xs-12 col-md-6">
        <picture>
          <source media="(min-width: 992px)" srcset="/assets/img/about-me/frontend_lg.png">
          <source media="(min-width: 480px)" srcset="/assets/img/about-me/alexander_koenig.jpg">
          <source media="(min-width: 0px)" srcset="/assets/img/about-me/alexander_koenig.jpg">
          <img class="img-responsive" src="/assets/img/home/seebensee.jpg"
               alt="Alexander Koenig">
        </picture>
        </div>
    </div>
  </article>
</section>













